import { Injectable } from '@angular/core';
import { AppSettings, AsamcoAuthService, Notification, NotificationData, NotificationService } from '@asamco/base';
import { bind } from '@asamco/utils';

import { AsamcoSignalrBase } from '../asamco-signalr-base';

// Default Asamco Icon
// const DEFAULT_ICON =
// 	'https://media.licdn.com/dms/image/C560BAQFgggP8bNeKyA/company-logo_200_200/0?e=2159024400&v=beta&t=bXybCtjRPygB2J0yydY3wkpcqOe_JniT_df-oeAmqj8';

@Injectable({
	providedIn: 'root',
	deps: [AsamcoAuthService, AppSettings, NotificationService],
})
export class NotificationSignalrService extends AsamcoSignalrBase {
	/**
	 * Our hubname to connect to
	 */
	protected hubName = 'notifications';

	/**
	 * The event name
	 */
	protected events = [{ methodName: 'Notify', newMethod: this.spawnNotification }];

	/**
	 *Creates an instance of NotificationSignalrService.
	 * @param {SignalR} signalr
	 * @param {AsamcoAuthService} auth
	 * @param {AppSettings} app
	 * @memberof NotificationSignalrService
	 */
	constructor(auth: AsamcoAuthService, app: AppSettings, private notificationsService: NotificationService) {
		super(auth, app);

		this.startService().subscribe({error: console.error});
	}

	/**
	 * Called when a notification signal is received
	 * @param not
	 */
	@bind
	private spawnNotification(notification: Notification<NotificationData>) {
		this.notificationsService.handle(notification, true);
	}
}
